import { Text } from "../design/text";
import { VisitationRotationBlock } from "../models/VisitationRotationBlock";
import SelectParentThumbnail from "./Fields/SelectParentAvatar";
import TimeButton from "./TimeButton";
import moment from "moment";

interface RotationDayEditorProps {
  block: VisitationRotationBlock;
  onChange: (updated: VisitationRotationBlock) => void;
  dayOffset: number;
  startDate: string;
  transitionRequired?: boolean;
}

export const RotationDayEditor = ({
  block,
  onChange,
  dayOffset,
  startDate,
  transitionRequired = false,
}: RotationDayEditorProps) => {
  const date = moment(startDate).add(dayOffset, "days");

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-white border rounded-md shadow-sm">
      <div>
        <div className="text-sm font-medium text-gray-900">
          {date.format("MMMM D")}{" "}
          <span className="text-gray-500">{date.format("dddd")}</span>
        </div>
        {transitionRequired && (
          <TimeButton
            value={block.time}
            onChange={(time) => onChange({ ...block, time })}
            trigger={({ onClick }) => (
              <Text onClick={onClick}>
                {block.time ? (
                  moment(block.time, "HH:mm").format("h:mm A")
                ) : (
                  <span className="font-bold text-red-500">
                    Transition time?
                  </span>
                )}
              </Text>
            )}
          />
        )}
      </div>
      <div>
        <SelectParentThumbnail
          label="Participant"
          value={block.participantId}
          onChange={(value) => onChange({ ...block, participantId: value! })}
        />
      </div>
    </div>
  );
};
